class CourseForm extends HTMLElement {
    constructor() {
        super();
        
        this.checkbox = this.querySelector('input[type="checkbox"].js-plus');
        this.form = this.querySelector('.shopify-product-form');
        this.submitButton = this.querySelector('#addCart');
        this.submitLink = this.querySelector('#addCartLink');
        this.priceElem = this.querySelector('[data-product-price]');
        this.oldPrice = this.querySelector('[data-compare-price]');
        this.extraText = this.querySelector('.product-form__extra:not(.never-hide)');

        this.switch = this.querySelector('.switch');

        if (this.switch) {   
            
            this.switch.addEventListener('click', this.selectedOption.bind(this));
        }

        this.toggleVariantList = this.querySelectorAll('input[type="radio"][name="plus"]');

        this.toggleVariantList.forEach(
            (toggle) => toggle.addEventListener('change', this.toggleVariants.bind(this))
          );



          
          if (this.checkbox) {
            this.checkbox.addEventListener('change', this.togglePlus.bind(this));
            this.togglePlus();
        }
  

  
    }

    checkRadioButtons() {
        var selected = document.querySelector('input[type="radio"][name="plus"]:checked');
        this.toggleVariants(selected);
        
    }

    selectedOption() {
        this.toggleVariantList = this.querySelectorAll('input[type="radio"][name="plus"]');
        this.toggleVariantList.forEach((toggle) => {
            if (!toggle.checked) {
                this.selectedOption = toggle;
            } 
        }
        );
        this.selectedOption.checked = true;
        this.checkRadioButtons();




    }

    togglePlus() {
        if (this.checkbox.checked) {
            this.form.classList.add('plus-active');
            this.submitButton.classList.add('hide');
            this.submitLink.classList.remove('hide');
            this.priceElem.innerHTML = this.toggleVariantList[0].dataset.price;
            this.oldPrice.classList.remove('hide');
            this.extraText.classList.remove('hide');
        } else {
            this.form.classList.remove('plus-active');
            this.submitButton.classList.remove('hide');
            this.submitLink.classList.add('hide');
            this.priceElem.innerHTML = this.priceElem.dataset.oldPrice;
            this.oldPrice.classList.add('hide');
            this.extraText.classList.add('hide');

        }
    } 

    toggleVariants(event) {
        if (event.target) {
            var element = event.target;
        } else {
            var element = event;
        }
        if (element.checked) {
            this.submitLink.href = element.dataset.link;
            this.priceElem.innerHTML = element.dataset.price;
            this.oldPrice.innerHTML = element.dataset.compare;
        }
        
    }
  
  
  
  }
  
  customElements.define('course-form', CourseForm);